import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { of, Subject } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { Store } from "../../../../@core/store/store";
import { CMS_FEEDS_DATA } from "./intranet.data";
// import { TokenService } from "c:/Users/99016952/Downloads/LttsFe/ltts_fe/src/app/@core/token/token.service";
import { TokenService } from "../../../../@core/token/token.service";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {
  ApproveRequestLoadedState,
  ApproveRequestLoadingErrorState,
  ApproveRequestLoadingState,
  CMSFeedsLoadedState,
  CMSFeedsLoadingErrorState,
  CMSFeedsLoadingState,
  DeclineRequestLoadedState,
  DeclineRequestLoadingErrorState,
  DeclineRequestLoadingState,
  FeedsDataLoadedState,
  FeedsDataLoadingErrorState,
  FeedsDataLoadingState,
  MyAttendanceDataLoadedState,
  MyAttendanceDataLoadingErrorState,
  MyAttendanceDataLoadingState,
  MyDailyAttendanceDataLoadedState,
  MyDailyAttendanceDataLoadingErrorState,
  MyDailyAttendanceDataLoadingState,
  DailyAttendanceDataLoadingState,
  DailyAttendanceDataLoadingErrorState,
  DailyAttendanceDataLoadedState,
  MyOrgDataLoadedState,
  MyOrgDataLoadingErrorState,
  MyOrgDataLoadingState,
  MyOrgMonthDataLoadedState,
  MyOrgMonthDataLoadingErrorState,
  MyOrgMonthDataLoadingState,
  MyTeamsDataLoadedState,
  MyTeamsDataLoadingErrorState,
  MyTeamsDataLoadingState,
  RequestsForApprovalsLoadedState,
  RequestsForApprovalsLoadingErrorState,
  RequestsForApprovalsLoadingState,
  UpcomingLeavesDataLoadedState,
  UpcomingLeavesDataLoadingErrorState,
  UpcomingLeavesDataLoadingState,
  UpdateWidgetOrderLoadedState,
  UpdateWidgetOrderLoadingErrorState,
  UpdateWidgetOrderLoadingState,
  ForexRequestLoadingState,
  ForexRequestLoadedState,
  ForexRequestLoadingErrorState
} from "./intranet.state";

@Injectable({
  providedIn: "root",
})
export class IntranetService extends Store.AbstractService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private http: HttpClient,
    private tokenService: TokenService) {
    super()
  }

  fetchRequestsForApprovals(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RequestsForApprovalsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.approvalRequests.endpoint,
      { emailId }
    );
    // const path = environment.api.intranet.approvalRequests.endpoint
    // const mockBase = "https://demo0404819.mockable.io/api/";

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RequestsForApprovalsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RequestsForApprovalsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  approveRequest(reqData) {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new ApproveRequestLoadingState());
    }, 0);
    const path = environment.api.intranet.approveRequest.endpoint;

    me.controller
      .post(path, reqData, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new ApproveRequestLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new ApproveRequestLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }

  async GetTownHallNotifications() {
    try {
      const token = await this.tokenService.getAccessToken();

      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`
      });

      return this.http.get(
        `${environment.api.core.base3}/ModernIntranet/Get-TownHallNotification`,
        { headers }
      );
    }
    catch (error) {
      console.error('Token error:', error);
      throw error;
    }
  }


  async markNotificationAsSeen() {
    try {
      const token = await this.tokenService.getAccessToken();
      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`
      });
      return this.http.post(
        `${environment.api.core.base3}/ModernIntranet/markSeen-Notification`,
        {},
        { headers }
      );
    } catch (error) {
      console.error('Token error:', error);
      throw error;
    }
  }




  declineRequest(reqData) {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new DeclineRequestLoadingState());
    }, 0);
    const path = environment.api.intranet.declineRequest.endpoint;

    // const path = me.controller.replaceVariables(
    //   environment.api.intranet.declineRequest.endpoint,
    //   { Attendance, empId, date, remark }
    // );

    me.controller
      .post(path, reqData, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new DeclineRequestLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new DeclineRequestLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }
  approveForexRequest(forexId) {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new ForexRequestLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.forexApproval.endpoint,
      { forexId }
    );

    me.controller
      .post(path, null, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new ForexRequestLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new ForexRequestLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }
  private cacheKeyFeed = "myCachedFeedData";


  fetchHomeFeedsData(): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new FeedsDataLoadingState());
    }, 0);


    const path = environment.api.cms.segments.endpoint;
    me.controller
      .get(path, null, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          localStorage.setItem(
            this.cacheKeyFeed,
            JSON.stringify({ data, cacheTime: new Date().getTime() })
          );
          output.next(new FeedsDataLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new FeedsDataLoadingErrorState(e));
          output.complete();
        }
      );
    return output;



  }


  fetchFeedsData(payload): any {
    const me = this;
    const output = new Subject<Store.State>();

    const cachedData = JSON.parse(localStorage.getItem(this.cacheKeyFeed));
    const now = new Date().getTime();

    setTimeout(() => {
      output.next(new FeedsDataLoadingState());
    }, 0);

    // Check if cached data exists and is valid
    if (cachedData && now - cachedData.cacheTime < this.cacheExpiration) {
      setTimeout(() => {
        // Emit cached data first, but do NOT complete the Subject here
        output.next(new FeedsDataLoadedState(cachedData.data));
      }, 0);
    }

    const path = environment.api.intranet.feeds.endpoint;
    me.controller
      .get(path, payload, environment.api.core.cmsBase, { Authorization: true })
      .subscribe(
        (data: any) => {
          localStorage.setItem(
            this.cacheKeyFeed,
            JSON.stringify({ data, cacheTime: new Date().getTime() })
          );
          output.next(new FeedsDataLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new FeedsDataLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }

  fetchMyOrgData(userEmail: string): any {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new MyOrgDataLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.myOrganization.endpoint,
      { userEmail }
    );
    // const mockBase = "https://demo0404819.mockable.io/";
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new MyOrgDataLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new MyOrgDataLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  fetchMyOrgDataByDate(userEmail: string, overviewDate: string): any {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new MyOrgDataLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.myOrganizationDatewise.endpoint,
      { userEmail, overviewDate }
    );
    // const mockBase = "https://demo0404819.mockable.io/";
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new MyOrgDataLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new MyOrgDataLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }


  fetchMyOrgDataByMonth(userEmail: string, overviewDate: string): any {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new MyOrgMonthDataLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.myOrganizationMonthwise.endpoint,
      { userEmail, overviewDate }
    );
    // const mockBase = "https://demo0404819.mockable.io/";
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new MyOrgMonthDataLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new MyOrgMonthDataLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  private upcomingLeaves = "upcomingLeaves";

  fetchUpcomingLeaveData(reqBody: any): any {
    const me = this;
    const output = new Subject<Store.State>();

    const cachedData = JSON.parse(localStorage.getItem(this.upcomingLeaves));
    const now = new Date().getTime();

    setTimeout(() => {
      output.next(new UpcomingLeavesDataLoadingState());
    }, 0);

    // Check if cached data exists and is valid
    if (cachedData && now - cachedData.cacheTime < this.cacheExpiration) {
      setTimeout(() => {
        // Emit cached data first, but do NOT complete the Subject here
        output.next(new UpcomingLeavesDataLoadedState(cachedData.data));
      }, 0);
    }

    const path = environment.api.intranet.myAttendance.endpoint;
    // const mockBase = "https://demo0404819.mockable.io/";
    me.controller
      .post(path, reqBody, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          localStorage.setItem(
            this.upcomingLeaves,
            JSON.stringify({ data, cacheTime: new Date().getTime() })
          );
          output.next(new UpcomingLeavesDataLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new UpcomingLeavesDataLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }

  private cacheKey = "myAttendanceCache";
  private cacheExpiration = 10 * 60 * 1000; // Cache expiration time in milliseconds (10 minutes)

  // Fetch attendance data and manage caching
  fetchMyAttendanceData(payload): any {
    const me = this;
    const output = new Subject<Store.State>();

    // Use month and year as part of the cache key to make the cache month-specific
    const cacheKeyUpdated = `${this.cacheKey}_${payload.emailID}_${payload.fromDate}_${payload.toDate}`;
    const cachedData = JSON.parse(localStorage.getItem(cacheKeyUpdated));
    const now = new Date().getTime();
    // Emit loading state immediately
    setTimeout(() => {
      output.next(new MyAttendanceDataLoadingState());
    }, 0);

    // Check if cached data exists and is valid
    if (cachedData && now - cachedData.cacheTime < this.cacheExpiration) {
      setTimeout(() => {
        output.next(new MyAttendanceDataLoadedState(cachedData.data));
      }, 0);
    } else {
      // Fetch fresh data from the API if cache is expired or doesn't exist
      const path = environment.api.intranet.myAttendanceNew.endpoint;
      me.controller
        .post(path, payload, undefined, { Authorization: true })
        .subscribe(
          (data: any) => {
            // Cache the fresh data using the updated cache key
            me.cacheDataWithKey(data, cacheKeyUpdated);

            // Emit fresh data and THEN complete the Subject
            output.next(new MyAttendanceDataLoadedState(data));
            output.complete();
          },
          (e: any) => {
            output.error(new MyAttendanceDataLoadingErrorState(e));
            output.complete();
          }
        );
    }

    return output;
  }

  fetchMyDailyAttendanceData(payload): any {
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new MyDailyAttendanceDataLoadingState());
    }, 0);
    const path = environment.api.intranet.myDailyAttendance.endpoint;
    this.controller
      .post(path, payload, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new MyDailyAttendanceDataLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new MyDailyAttendanceDataLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }


  fetchDailyAttendanceData(payload): any {
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new DailyAttendanceDataLoadingState());
    }, 0);
    const path = environment.api.intranet.dailyAttendance.endpoint;
    this.controller
      .post(path, payload, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new DailyAttendanceDataLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new DailyAttendanceDataLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }

  // Cache data with a specific key for the month and year
  private cacheDataWithKey(data: any, cacheKey: string) {
    const cacheData = {
      data: data,
      cacheTime: new Date().getTime(),
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  }

  // Clear cache for specific months and years
  clearAttendanceCache(month: string, year: string) {
    const cacheKeyPrefix = `${this.cacheKey}_${month}_${year}`;

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(cacheKeyPrefix)) {
        localStorage.removeItem(key);
      }
    }
  }

  fetchMyTeamsData(payloadData): any {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new MyTeamsDataLoadingState());
    }, 0);

    const path = environment.api.intranet.myTeams.endpoint;
    // const mockBase = "https://demo2793233.mockable.io/";
    me.controller
      .post(path, payloadData, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new MyTeamsDataLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new MyTeamsDataLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }

  fetchCMSfeeds(): any {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new CMSFeedsLoadingState());
    }, 0);
    setTimeout(() => {
      output.next(new CMSFeedsLoadedState(CMS_FEEDS_DATA));
    }, 300);
    return output;
    const path = environment.api.intranet.myAttendance.endpoint;
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new CMSFeedsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new CMSFeedsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }
async fetchAppraisalData() {
  try {
    const token = await this.tokenService.getAccessToken();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.post(
      `${environment.api.core.base3}/ModernIntranet/check-appraisal-pending`,                  // ✅ body (empty)
       {},
      { headers }           
    );
  } catch (error) {
    console.error('Token error:', error);
    throw error;
  }
}
  updateWidgetOrder(payloadData, userId): any {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new UpdateWidgetOrderLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(
      environment.api.intranet.widgetOrder.endpoint,
      { userId }
    );
    me.controller
      .post(path, payloadData, undefined, { Authorization: true })
      .subscribe(
        (data: any) => {
          output.next(new UpdateWidgetOrderLoadedState(data));
          output.complete();
        },
        (e: any) => {
          output.error(new UpdateWidgetOrderLoadingErrorState(e));
          output.complete();
        }
      );
    return output;
  }
  async fetchTalentAI() {
    try {
      const token = await this.tokenService.getAccessToken();
      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`
      });
      return this.http.post(
        `${environment.api.core.base3}/ModernIntranet/check-talentai-completion`,
        {}, // empty body
        { headers } // headers as options
      )
    }
    catch (error) {
      console.error('Token error:', error);
      throw error;
    }
  }
}
